module.exports={render:function (){with(this) {
  return _h('div', {
    attrs: {
      "id": "app"
    }
  }, [_h('dbfunctions'), " ", _h('headerblock'), " ", _h('transition', {
    attrs: {
      "appear": "",
      "name": "fade",
      "mode": "out-in"
    }
  }, [_h('router-view')]), " ", _h('footerblock')])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 80
 ** module chunks = 2
 **/